import * as yup from 'yup';

import { AddressFieldsFormFields } from 'src/constants/address';
import {
  ERROR_MESSAGE_REQUIRED_ZIP_CODE,
  emailValidationSchema,
  numberOfEmployeesSimpleValidationSchema,
  phoneNumberValidationSchema,
  taxYearEndDateSimpleValidationSchema,
  zipCodeValidationSchema,
} from 'src/constants/validation';
import { REQUIRED_VALIDATION_MESSAGE } from 'src/constants/validationMessage';

import { CompanyInformationFormEmployerAdminFields } from '../types';

export const companyInformationFormEmployerAdminValidationSchema = yup.object({
  [CompanyInformationFormEmployerAdminFields.displayName]: yup
    .string()
    .nullable()
    .required(REQUIRED_VALIDATION_MESSAGE),
  [CompanyInformationFormEmployerAdminFields.contactEmail]: emailValidationSchema
    .nullable()
    .required(REQUIRED_VALIDATION_MESSAGE),
  [CompanyInformationFormEmployerAdminFields.contactPhoneNumber]: phoneNumberValidationSchema,
  [CompanyInformationFormEmployerAdminFields.industry]: yup.string().nullable(),
  [CompanyInformationFormEmployerAdminFields.corporateStructure]: yup.string().nullable(),
  [CompanyInformationFormEmployerAdminFields.numberOfEmployees]:
    numberOfEmployeesSimpleValidationSchema,
  [CompanyInformationFormEmployerAdminFields.taxYearEndDate]: taxYearEndDateSimpleValidationSchema,
  [CompanyInformationFormEmployerAdminFields.disclaimer]: yup.string().nullable(),
  [CompanyInformationFormEmployerAdminFields.headquarters]: yup.object({
    [AddressFieldsFormFields.street]: yup.string().required('Required street'),
    [AddressFieldsFormFields.city]: yup.string().required('Required city'),
    [AddressFieldsFormFields.county]: yup.string().nullable(),
    [AddressFieldsFormFields.state]: yup.string().required('Required state'),
    [AddressFieldsFormFields.zipCode]: zipCodeValidationSchema.required(
      ERROR_MESSAGE_REQUIRED_ZIP_CODE,
    ),
  }),
});
